import { ThemeService } from './../../services/theme.service';
import { Component, OnInit } from '@angular/core';
import { EscolaService } from '../services/escola.service';
import { SerieService } from '../services/serie.service';
import { TurmaService } from '../services/turma.service';
import { AlunoService } from '../services/aluno.service';
import { PoaPeriodoService } from '../services/poa-periodo.service';
import { AlunosModel } from './alunos.model';
import { LoaderService } from 'src/app/shared/loader/loader.service';
import { Router } from '@angular/router';
import { TurmaModel } from '../models/turmas.model';

interface FilterProps {
    title: string;
    notSelectedText: string;
    selected?: string;
    items: { nome: string; id: string; active?: boolean }[];
    show?: boolean;
    loading?: boolean;
}

interface RequestError {
    code: string;
    message: string;
}

@Component({
    selector: 'app-student',
    templateUrl: './alunos.component.html',
    styleUrls: ['./alunos.component.scss'],
})
export class AlunosComponent implements OnInit {
    public filters: {
        title: string;
        notSelectedText: string;
        label?: string;
        selected?: string;
        items: { nome: string; id: string; active?: boolean }[];
        show?: boolean;
        chosen?: boolean;
        loading?: boolean;
    }[];

    constructor(
        private poaPeriodoService: PoaPeriodoService,
        private escolaService: EscolaService,
        private serieService: SerieService,
        private turmaService: TurmaService,
        public alunoService: AlunoService,
        private loaderService: LoaderService,
        private router: Router,
        private themeService: ThemeService
    ) {
        this.filters = [];
    }

    numOfFilter = [true, false, false, false];

    alunos: AlunosModel[] = [];

    showClearAllBtn = false;

    indexAtualSelecionado: number;

    error: RequestError;

    private themeWrapper = document.documentElement;

    global() {
        this.themeWrapper.style.setProperty('--primary', 'blue');
        this.themeWrapper.style.setProperty('--primary-light', 'deepskyblue');
    }

    ngOnInit(): void {
      this.themeService.setGlobalTheme();
      this.getPeriodos();
    }

    getPeriodos() {
        this.poaPeriodoService.getPeriodos().subscribe((p) => {
            const periodos: FilterProps = {
                title: 'Período',
                notSelectedText: 'Escolha o período da POA: ',
                items: p,
                show: true,
            };
            const pushed = this.filters.push(periodos);

            if (p.length === 1) {
                this.selectItem(p[0].id, pushed - 1);
                this.numOfFilter[0] = false;
            }

            this.loaderService.hide();
        }, (error => {
            this.loaderService.hide();
        }));
    }

    getEscolas(hash: string) {
        this.numOfFilter[0] = false;
        this.numOfFilter[1] = true;
        this.escolaService.getPorPeriodo(hash).subscribe((es) => {
            const escolas: FilterProps = {
                title: 'Escola',
                notSelectedText: 'Escolha uma escola: ',
                items: es,
                show: true,
            };

            const pushed = this.filters.push(escolas);

            if (es.length === 1) {
                this.selectItem(es[0].id, pushed - 1);
                this.numOfFilter[1] = false;
            }

            this.loaderService.hide();
        }, (error => {
            this.loaderService.hide();
        }));
    }

    atualizarEscolas(hashPeriodo: string, index: number) {
        this.alunos = [];
        this.numOfFilter[0] = false;
        this.numOfFilter[1] = true;

        if (this.filters[3] && this.filters[2]) {
            this.filters[2].show = false;
            this.filters[3].show = false;
        }

        this.loaderService.show();
        const escola = this.filters[index + 1];

        this.escolaService.getPorPeriodo(hashPeriodo).subscribe((es) => {
            if (es.length < 1) {
                escola.show = false;
                return;
            }

            this.clearFilter(index + 1);
            this.clearFilter(index + 1);
            this.filters[index + 1].show = false;

            escola.show = true;
            escola.items = es;
            this.loaderService.hide();
        }, (error => {
            this.loaderService.hide();
        }));
    }

    getSeries(hashEscola: string, hashPeriodo: string) {
        this.numOfFilter[1] = false;
        this.numOfFilter[2] = true;
        this.loaderService.show();
        this.serieService.getPorEscola({hashEscola: hashEscola, hashPeriodo: hashPeriodo}).subscribe((se) => {
            const series: FilterProps = {
                title: 'Série',
                notSelectedText: 'Escolha uma série: ',
                items: se,
                show: true,
            };

            const pushed = this.filters.push(series);

            if (se.length === 1) {
                this.selectItem(se[0].id, pushed - 1);
                this.numOfFilter[2] = false;
            }

            this.loaderService.hide();

        }, (error => {
            this.loaderService.hide();
        }));
    }

    updateSeries(hashEscola: string, index: number) {
        this.alunos = [];
        this.numOfFilter[1] = false;
        this.numOfFilter[2] = true;

        if (this.filters[3]) {
            this.filters[3].show = false;
        }

        this.loaderService.show();
        const serie = this.filters[index + 1];

        this.serieService.getPorEscola({hashEscola: hashEscola, hashPeriodo: this.hashPeiodoSelecionado}).subscribe((se) => {
            if (se.length < 1) {
                serie.show = false;
                return;
            }

            this.clearFilter(index + 1);
            this.filters[index + 1].show = false;

            serie.show = true;
            serie.items = se;
            this.loaderService.hide();

        }, (error => {
            this.loaderService.hide();
        }));
    }

    getTurmas() {
        this.loaderService.show();
        this.numOfFilter[2] = false;
        this.numOfFilter[3] = true;
        const hashses = {
            hashPeriodo: this.filters[0].items.find((x) => x.active).id,
            hashEscola: this.filters[1].items.find((x) => x.active).id,
            hashSerie: this.filters[2].items.find((x) => x.active).id,
        };

        this.turmaService.getTurmas(hashses).subscribe((tr) => {
            const turma: FilterProps = {
                title: 'Turma',
                notSelectedText: 'Escolha uma turma: ',
                items: tr,
                show: tr.length < 1 ? false : true,
            };

            const pushed = this.filters.push(turma);

            if (turma.items.length > 1) {
                const todos: TurmaModel = {
                    id: 'all',
                    nome: 'Todas',
                };
                turma.items.unshift(todos);
            }

            if (tr.length === 1) {
                this.selectItem(tr[0].id, pushed - 1);
            }

            this.loaderService.hide();

        }, (error => {
            this.loaderService.hide();
        }));
    }

    updateTurmas(index: number) {
        this.numOfFilter[2] = false;
        this.numOfFilter[3] = true;
        this.alunos = [];
        this.loaderService.show();

        const hashses = {
            hashPeriodo: this.filters[0].items.find((x) => x.active).id,
            hashEscola: this.filters[1].items.find((x) => x.active).id,
            hashSerie: this.filters[2].items.find((x) => x.active).id,
        };

        const turma = this.filters[index + 1];

        if (!turma) {
            // Não Há turmas
            return;
        }
        this.turmaService.getTurmas(hashses).subscribe((tr) => {
            if (tr.length < 1) {
                this.loaderService.hide();
                turma.show = false;
                return;
            }

            turma.show = true;
            turma.items = tr;

            if (turma.items.length > 1) {
                const todos: TurmaModel = {
                    id: 'all',
                    nome: 'Todas',
                };
                turma.items.push(todos);
            }

            this.clearFilter(index + 1);
            this.loaderService.hide();

            if (tr.length === 1) {
                this.selectItem(tr[0].id, index + 1);
            }

        }, (error => {
            this.loaderService.hide();
        }));
    }

    getAlunos(id: string) {
        if (id === 'all') {
            const hashses = {
                hashPeriodo: this.filters[0].items.find((x) => x.active).id,
                hashEscola: this.filters[1].items.find((x) => x.active).id,
                hashSerie: this.filters[2].items.find((x) => x.active).id,
            };

            this.alunoService
                .getAlunosDeTodasAsTurmas(
                    hashses.hashPeriodo,
                    hashses.hashEscola,
                    hashses.hashSerie
                )
                .subscribe((aluno) => 
                    (this.alunos = aluno), 
                    (error => {
                        this.loaderService.hide();
                    }));
            return;
        }

        this.alunoService.getAlunoPorTurma(id)
            .subscribe((aluno) => 
                (this.alunos = aluno), 
                (error => {
                    this.loaderService.hide();
                }));
    }

    hashPeiodoSelecionado:string = "";
    selectItem(id: string, index: number) {
        const filteredItems = this.filters[index].items.find((item) => item.id === id);

        this.filters[index].selected = id;
        this.filters[index].label = filteredItems.nome;

        filteredItems.active = true;

        switch (index) {
            case 0:                
                this.hashPeiodoSelecionado = id;
                if (this.filters[index].chosen) {
                    this.atualizarEscolas(id, index);
                    break;
                }                
                this.getEscolas(id);
                this.filters[index].chosen = true;
                this.indexAtualSelecionado = index;
                break;
            case 1:
                if (this.filters[index].chosen) {
                    this.updateSeries(id, index);
                    break;
                }
                this.getSeries(id, this.hashPeiodoSelecionado);
                this.filters[index].chosen = true;
                this.indexAtualSelecionado = index;
                break;
            case 2:
                if (this.filters[index].chosen) {
                    this.updateTurmas(index);
                    break;
                }
                this.getTurmas();
                this.filters[index].chosen = true;
                this.indexAtualSelecionado = index;
                break;
            case 3:
                this.getAlunos(id);
                this.showClearAllBtn = true;
                break;
        }
    }

    selectStudent(token: string) {
        this.alunoService.validarTokenAluno(token).subscribe(
            (aluno) => {
                console.log(aluno);
                const currentLang = window.location.pathname.split('/')[1];
                this.router.navigate([`/${currentLang}/questionario`, token]);
            },
            (err) => {
              this.loaderService.hide();
              this.error = err.errors?.find(f=> f.message)?.message;
            }
        );

        // Abre em outra aba do browser
        // const alunoUrl = this.router.serializeUrl(
        //     this.router.createUrlTree([`/${currentLang}/questionario`, token])
        // );
        // window.open(alunoUrl, '_blank');
    }

    clearFilter(indexFilter: number) {
        this.error = undefined;
        this.alunos = [];
        this.filters[indexFilter].selected = '';
        this.filters[indexFilter].label = '';
        this.filters[indexFilter].items.forEach((item, index) => {
            item.active = false;
        });
    }

    clearAllFilters() {
        this.alunos = [];
        this.error = undefined;
        this.showClearAllBtn = false;
        this.numOfFilter = [true, false, false, false];

        const filters = this.filters;
        filters.map((filter) => {
            filter.selected = '';
            filter.label = '';
            filter.items.map((item) => (item.active = false));
            filter.show = false;
        });

        filters[0].show = true;

        if (filters[0].items.length === 1) {
            this.selectItem(filters[0].items[0].id, 0);
            this.numOfFilter[0] = false;
        }
    }

}
